export const arcProject = {
  id: 3, 
  slug: 'arc',
  title: 'Arc AIO', 
  description: 'All-In-One collectibles and sneaker bot', 
  tags: ['desktop app', 'design'],
  image: '/arc/Arc - Cover.png',
  logo: '/arc/Arc - Logo.png',
  heroLogo: '/arc/Arc - Logo no BG.svg',
  heroImage: '/arc/Arc - Desktop.png',
  heroDescription: 'An all-in-one sneaker and collectibles bot designed to help users secure high-demand items in Canada.',
  headerBackground: '#587EAF',
  meta: {
    role: 'UI/UX Designer',
    timeline: '1 month',
    tools: 'Figma, Illustrator',
  },
  liveUrl: '',
  overview: {
    title: 'Overview',
    paragraphs: [
      'Arc AIO is an all-in-one collectibles and sneaker bot designed to give users an advantage when purchasing high-demand items across an expansive list of supported sites in Canada. The project included designing the desktop application, website, and brand identity as a cohesive system.',
    ],
  },
  goal: {
    title: 'Goal',
    description: 'The goal was to create a powerful yet approachable experience for sneaker and collectibles enthusiasts, informed by insights from existing sneaker bot users, while balancing advanced functionality with clarity and ease of use.',
  },
  userResearch: {
    title: 'Talking to users',
    description: 'Interviews with sneaker bot users - from small-scale operators to high-volume power users - revealed a consistent failure point: existing bots do not scale with the user.\n\nAs task volume increases, visibility, control, and confidence break down. Current tools optimize for execution speed, but provide minimal UI/UX support for managing complex, time-critical workflows.',
    problemImages: [
      '/arc/Arc - Problem.jpg',
      '/arc/Arc - Problem 2.jpg',
      '/arc/Arc - Problem 3.jpg',
    ],
    keyFinding: '',
    keyIssue: 'Botting at high volumes is difficult to manage.',
    quotes: [
      'Botting at high volumes is difficult to manage.',
      'it\'s really easy to lose track of what\'s going on',
      'The bot works, but managing it is way harder than it should be.',
    ],
    problemSection: {
      title: 'Defining the Problem',
      description: 'This insight became the core problem to solve. I reframed user pain points into a set of "How might we" questions to explore system-level opportunities focused on improving control, clarity, and efficiency at scale.',
    },
    image: '/arc/Arc - How Might We.png',
  },
  finalDesign: {
    title: 'Introducing Arc',
    description: 'The redesigned system includes:\n\n• Centralized dashboards for tasks, profiles, and workflow status\n\n• Bulk-edit functionality for keywords, product IDs, and tasks\n\n• Selective profile assignment across task groups\n\n• Modular components supporting scalable workflows\n\nDesign decisions prioritized system-level thinking, ensuring updates or bulk edits do not cascade into errors elsewhere.',
    images: [
      '/arc/Arc - Tasks.png',
      '/arc/Arc - Profiles.png',
      '/arc/Arc - UI.png',
      { src: '/arc/Arc - Promotional Post.png', caption: 'Promotional Post' },
    ],
    content: [
      {
        title: 'Task groups',
        description: 'Organization for tasks & proxies to be able to bot at high volumes easily.',
      },
      {
        title: 'Mass edit mode',
        description: 'Edit all button to mass edit keywords/ID, profiles or proxies',
      },
      {
        title: 'Profile groups',
        description: 'Easily categorize profiles for easy access when making tasks',
        imageRight: true,
      },
    ],
  },
  visualTreatment: {
    title: 'Brand Identity',
    description: 'I designed a visual identity that balances clarity with personality. Color, typography, and iconography establish a recognizable brand while surfacing critical states and maintaining consistency across the platform—allowing users to quickly understand, trust, and engage with the experience.',
    image: '/arc/Arc - Branding.png',
  },
};
